import React from "react";
import { withStyles } from "@material-ui/core/styles";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Grid,
  IconButton,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { postData } from "../../../../api/componentAPIs";
import { observer, inject } from "mobx-react";
import Events from "../../../../utilities/EventEmitter";
import MESSAGES from "../../../../appMessages";
import { compose } from "recompose";
import { withSnackbar } from "notistack";
import { withUserProfile } from "../../../../userProfile/userProfileContext";
const OptimizationLoader = React.lazy(() => import("./Loader"));
import { reassignPickup } from "../../../modules/Dispatch/RouteExecution/utils/pickupActions";
import { getPickupsRouteData } from "../../../modules/Dispatch/RouteExecution/DriverMap/utils";
import { PICKUP_OPTIMYZER_STEPS } from "./constants";
import ActionButtons from "./StepperComponent/ActionButtons";
import StepperButtons from "./StepperComponent/StepperButtons";
import OptimizationStepper from "./StepperComponent/OptimizationStepper";
import OptimizationStepContent from "./StepperComponent/OptimizationStepContent";
import { v4 as uuidv4 } from "uuid";
import { getDriverAssignmentsList } from "../../../modules/Dispatch/RouteExecution/Recommendations/common/utils";
import {
  getSelectedPickupsByPickupId,
  getShowPickupsListWhenPickupsSelectedInGrid,
  getAllUnassignedPickups,
  isPickupSelectedInGrid,
  getReassignPickupDetail,
  getKPIDetails,
} from "./utils";
import styles from "./styles";
@inject("DispatchStore")
@observer
class DispatchOptimizationDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeStep: 0,
      completed: new Set(),
      skipped: new Set(),
      steps: PICKUP_OPTIMYZER_STEPS,
      progressPercentage: 0,
      driverAssignmentsList: [],
      driverRecommendedPickupSelected: [],
      unassignPickupSelected: [],
      unassignPickupDropdownError: {},
      kpiData: {},
      logData: [],
      notifyInProgress: false,
      pickupUpdateInProgress: false,
      selectedPickupsList: [],
      showPickupsList: [],
    };
  }

  componentDidMount() {
    Events.on("ShowpickupOptimizationLogs", this.showPickupOptimizationLogs);
    const { showPickupsList, selectedPickupsList } = this.getPickupsData();
    this.setState({
      showPickupsList,
      selectedPickupsList,
      startTime: new Date(),
    });
  }

  componentWillUnmount() {
    Events.removeListener(
      "ShowpickupOptimizationLogs",
      this.showPickupOptimizationLogs
    );
  }

  getPickupsData = () => {
    const { groupHeaderPickupIdsForSelectedPickups, pickupListForOptimization } =
      this.props.DispatchStore;
    if (!isPickupSelectedInGrid(groupHeaderPickupIdsForSelectedPickups)) {
      const allUnassignedPickups = getAllUnassignedPickups(
        pickupListForOptimization
      );
      return {
        showPickupsList: allUnassignedPickups,
        selectedPickupsList: allUnassignedPickups,
      };
    }
    return {
      showPickupsList : getShowPickupsListWhenPickupsSelectedInGrid(
        pickupListForOptimization,
        groupHeaderPickupIdsForSelectedPickups
      ),
      selectedPickupsList: getSelectedPickupsByPickupId(
        pickupListForOptimization,
        groupHeaderPickupIdsForSelectedPickups
      )
    }
  };

  getStepContentProps = (step) => {
    switch (step) {
      case 0:
        return {
          step,
          props: {
            userData: this.props.userData,
            glEventHub: this.props.glEventHub,
            setSelectedPickups: this.setSelectedPickups,
            showPickupUpdateInProgress: this.showPickupUpdateInProgress,
            hidePickupUpdateInProgress: this.hidePickupUpdateInProgress,
            selectedPickupsList: this.state.selectedPickupsList,
            showPickupsList: this.state.showPickupsList,
          },
        };
      case 1:
        return {
          step,
          props: {
            userData: this.props.userData,
            glEventHub: this.props.glEventHub,
            driverAssignmentsList: this.state.driverAssignmentsList,
            driverRecommendedPickupSelected: this.state.driverRecommendedPickupSelected,
            routesList: this.props.DispatchStore.routesList,
            unassignPickupSelected: this.state.unassignPickupSelected,
            unassignPickupDropdownError: this.state.unassignPickupDropdownError,
            handleUnassignPickupSelection: this.handleUnassignPickupSelection,
            handleAssignPickupSelection: this.handleAssignPickupSelection,
          },
        };
      case 2:
        return {
          step,
          props: {
            kpiData: this.state.kpiData,
            logData: this.state.logData,
          },
        };
    }
  };

  totalSteps = () => {
    return this.state.steps.length;
  };

  isLastStep = () => {
    return this.state.activeStep === this.totalSteps() - 1;
  };

  handleNext = () => {
    const newCompleted = this.state.completed;
    newCompleted[this.state.activeStep] = true;
    const newActiveStep = this.isLastStep()
      ? this.state.steps.findIndex((step, i) => !this.state.completed.has(i))
      : this.state.activeStep + 1;
    this.setState({ completed: newCompleted, activeStep: newActiveStep });
  };

  handleBack = () => {
    this.setState({
      activeStep: this.state.activeStep - 1,
      driverAssignmentsList: [],
      driverRecommendedPickupSelected: [],
      unassignPickupSelected: [],
      unassignPickupDropdownError: {},
      pickupUpdateInProgress: false,
    });
  };

  setSelectedPickups = (pickups) => {
    this.setState({ selectedPickupsList: pickups });
  };

  handleUnassignPickupSelection = (unassignPickupSelected) => {
    this.setState({
      unassignPickupSelected,
      unassignPickupDropdownError: this.getUnassignPickupDropdownError(
        unassignPickupSelected
      ),
    });
  };

  handleAssignPickupSelection = (assignedPickups) => {
    this.setState({
      driverRecommendedPickupSelected: assignedPickups,
    });
  };

  showPickupOptimizationLogs = (eventData, event) => {
    const logData = this.state.logData;
    const route = getPickupsRouteData(
      this.props.DispatchStore.routesList,
      eventData
    );
    if (!route) {
      return;
    }
    let pickupIds = eventData.pickupIds;
    if (eventData.success) {
      pickupIds = [eventData.pickupId];
    }
    // handle in case of failure of pickup assignment
    const pickupNumbers = this.props.DispatchStore.pickupListForOptimization.filter(
      (p) => pickupIds.includes(p.pickupId?.toUpperCase())
    ).map(p => p.pickupNumber)
    if (!pickupNumbers.length) {
      return;
    }
    logData.push({
      event,
      shipperName: eventData.shipperName,
      driverNumber: route.driverNumber,
      driverName: route.driverName,
      pickupNumber: pickupNumbers.join(","),
      success: eventData.success
    });
    this.setState({ logData });
  };

  updateOptimizationSolutionList = (driverAssignments) => {
    const { pickupsList, currentActiveRoutes } = this.props.DispatchStore;
    let driverAssignmentsList = getDriverAssignmentsList({
      pickupsList,
      currentActiveRoutes,
      driverAssignments,
      isPickupOptimizationFlow: true
    });
    this.setState({ driverAssignmentsList }, () => {
      this.handleNext();
    });
  };

  optymize = () => {
    if (this.props.DispatchStore.routesList.length > 0) {
      this.setState({ progressPercentage: 5 });
      const optimizePickupData = this.state.selectedPickupsList.map(
        (pickup) => {
          return { groupId: pickup.groupId, routeId: pickup.routeId };
        }
      );
      const data = {
        terminalCode: this.props.userData.userProfile.terminal.code,
        optimizePickups: optimizePickupData,
        eventDateTime: new Date(),
        runId: uuidv4().toUpperCase(),
      };
      postData("PickupOptimize", data).then(
        (response) => {
          if (response && response.status >= 200 && response.status < 400) {
            this.updateOptimizationSolutionList(
              response.data.driverAssignments
            );
            this.setState({ progressPercentage: 0 });
          } else {
            this.handleError(response.status);
          }
        },
        () => {
          this.handleError();
        }
      );
    } else {
      this.setState({ progressPercentage: 0 });
      this.props.enqueueSnackbar(
        MESSAGES.OPTIMIZATION_PICKUP.NO_ACTIVE_DRIVER,
        { variant: "error" }
      );
    }
  };

  handleError = (statusCode) => {
    this.setState({ progressPercentage: 0 });
    if (statusCode === 403) {
      return;
    }        
    this.props.enqueueSnackbar(
      MESSAGES.OPTIMIZATION_PICKUP.OPTIMIZATION_FAILURE,
      { variant: "error" }
    );  
  }

  showPickupUpdateInProgress = () => {
    this.setState({ pickupUpdateInProgress: true });
  };

  hidePickupUpdateInProgress = () => {
    this.setState({ pickupUpdateInProgress: false });
  };

  getUnassignPickupDropdownError = (unassignPickupSelected) => {
    return unassignPickupSelected.reduce((acc, unassignPickup) => {
      if (unassignPickup.driverId) {
        acc[unassignPickup.pickupId] = null;
      } else {
        acc[unassignPickup.pickupId] = "* Required";
      }
      return acc;
    }, {});
  };

  acceptNotify = () => {
    const {
      driverRecommendedPickupSelected,
      unassignPickupSelected,
      unassignPickupDropdownError,
    } = this.state;
    this.setState(
      {
        unassignPickupDropdownError: this.getUnassignPickupDropdownError(
          unassignPickupSelected
        ),
      },
      () => {
        if (Object.values(unassignPickupDropdownError).filter(Boolean).length) {
          return;
        }
        this.setState({ notifyInProgress: true });
        const reassignPickupDetail = getReassignPickupDetail([
          ...driverRecommendedPickupSelected,
          ...unassignPickupSelected,
        ]);
        reassignPickup({
          pickupDetails: reassignPickupDetail,
          terminalCode: this.props.userData.userProfile.terminal.code,
          DispatchStore: this.props.DispatchStore,
          showConfirmation: false,
          enqueueSnackbar: this.props.enqueueSnackbar,
        })
          .then(() => {
            const kpi = getKPIDetails(reassignPickupDetail, this.state.startTime);
            this.setState({
              kpiData: kpi,
            });
            this.handleNext();
          })
          .catch(() => {
            this.setState({ notifyInProgress: false });
            this.props.enqueueSnackbar(
              MESSAGES.OPTIMIZATION_PICKUP.REASSIGNMENT_FAILURE,
              { variant: "error" }
            );
          });
      }
    );
  };

  render() {
    const { classes, onClose } = this.props;
    const {
      activeStep,
      steps,
      progressPercentage,
      selectedPickupsList,
      driverRecommendedPickupSelected,
      unassignPickupSelected,
      pickupUpdateInProgress,
      notifyInProgress,
      completed,
      unassignPickupDropdownError,
    } = this.state;
    const { theme } = this.props.userData.userProfile || {};
    return (
      <Dialog
        disableBackdropClick
        open={true}
        disableEscapeKeyDown
        aria-labelledby="DispatchOptimizationDialog"
        classes={{ paper: classes.dialog }}
        onClose={onClose}
        maxWidth="xl"
        className={`${classes.dialogWrapper} ${theme} `}
      >
        <DialogTitle className={classes.noPadding}>
          {progressPercentage == 0 && (
            <Grid container item xs={12}>
              <Grid item md={11} xs={10}></Grid>
              <Grid item md={1} xs={2} className={classes.closeBtn}>
                <IconButton
                  aria-label="close"
                  className={classes.closeButton}
                  onClick={onClose}
                >
                  <CloseIcon />
                </IconButton>
              </Grid>
            </Grid>
          )}
        </DialogTitle>
        <DialogContent
          classes={{ root: classes.dialogContent }}
          className="customScroll"
        >
          <div className={classes.contentContainer}>
            <OptimizationStepper
              classes={classes}
              steps={steps}
              activeStep={activeStep}
              completed={completed}
              progressPercentage={progressPercentage}
            />

            {progressPercentage > 0 ? (
              <OptimizationLoader
                progressPercentage={progressPercentage}
              />
            ) : (
              <div className={classes.instructions}>
                <OptimizationStepContent
                  {...this.getStepContentProps(activeStep)}
                />
              </div>
            )}
          </div>
        </DialogContent>
        {progressPercentage == 0 && (
          <DialogActions classes={{ root: classes.dialogAction }}>
            <ActionButtons
              activeStep={activeStep}
              totalSteps={this.totalSteps()}
              handleBack={this.handleBack}
              onClose={onClose}
              buttonContent={StepperButtons(
                activeStep,
                classes,
                selectedPickupsList,
                driverRecommendedPickupSelected,
                unassignPickupSelected,
                pickupUpdateInProgress,
                notifyInProgress,
                this.optymize,
                this.acceptNotify,
                onClose,
                unassignPickupDropdownError,
              )}
            />
          </DialogActions>
        )}
      </Dialog>
    );
  }
}
export default compose(
  withStyles(styles),
  withSnackbar,
  withUserProfile
)(DispatchOptimizationDialog);
